<template>
    <div class="form-group">
        <label :for="id" v-if="!!label"
            >{{ label }}
            <span class="form-required" v-if="!!required">*</span></label
        >
        <!-- <div class="form-wrap"> -->
        <input
            :name="name"
            class="form-control"
            :ref="id"
            :id="id"
            :value="startAddress"
            @input="onInputChange"
            :readonly="readOnly"
        />
        <!-- </div> -->
        <input ref="lat" hidden :name="latitudeName" :value="lat" />
        <input ref="lng" hidden :name="longitudeName" :value="lng" />
    </div>
</template>

<script>
export default {
    data: () => ({
        autocomplete_input: null,
        position: null
    }),
    props: {
        id: {
            type: String,
            default: "map_autocomplete",
            required: false
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        name: {
            type: String,
            default: "address",
            required: false
        },
        latitudeName: {
            type: String,
            default: "latitude",
            required: false
        },
        longitudeName: {
            type: String,
            default: "longitude",
            required: false
        },
        label: {
            type: String,
            default: "",
            required: false
        },
        pos: {
            type: Object,
            default: () => ({}),
            required: false
        },
        readOnly: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        lat: function() {
            if (!!this.position) return this.position.lat;
        },
        lng: function() {
            if (!!this.position) return this.position.lng;
        },
        startAddress: function() {
            if (!!this.position) return this.position.address;
        }
    },
    methods: {
        getAddressData: function() {
            var place = this.autocomplete_input.getPlace();
            this.position = {
                address: this.$refs[this.id].value,
                formatted_address: place.formatted_address,
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };
            this.$emit("placeSelected", this.position);
        },
        onInputChange: function() {
            var input = this.$refs[this.id].value;
            if (!input) {
                this.$emit("placeCleared");
                this.position = null;
            }
        }
    },
    created: function() {
        if (!!this.pos) {
            this.position = this.pos;
        }
    },
    mounted: function() {
        var options = {
            componentRestrictions: { country: ["it", "ch", "fr", "at", "be", "bg", "hr", "cz", "dk", "de", "gr", "hu", "ee", "fi", "ie", "lv", "lt", "lu", "nl", "po", "pt", "ro", "sk", "si", "es", "se", "al", "ad", "am", "by", "ba", "xk", "li", "mk", "mc", "me", "md", "no", "sm", "rs", "ua", "gb", "va"]}
        };
        var fields = ["name", "formatted_address", "geometry"];
        this.autocomplete_input = new google.maps.places.Autocomplete(
            this.$refs[this.id],
            options
        );
        this.autocomplete_input.setFields(fields);
        this.autocomplete_input.addListener(
            "place_changed",
            this.getAddressData
        );
    }
};
</script>
